import { useEffect, useState } from "react"
import { type OrderItemType } from "../types"

const API_URL = '/api/store/orders/nft/'

export const useOrderHistory = () => {
    const [items, setItems] = useState<OrderItemType[]>([])
    const [isLoading, setIsLoading] = useState(true);
    const [isFetched, setIsFetched] = useState(false);

    useEffect(() => {
        async function fetchOrderHistory() {
            setIsLoading(true);
            try {
                const response = await fetch(API_URL)
                const result = await response.json()
                setItems(result.items)
                setIsFetched(true);
            } finally {
                setIsLoading(false);
            }
        }
        fetchOrderHistory()
    }, [])

    return {
        items,
        isLoading,
        isFetched,
    }
}